import React, { useState } from "react";
import { 
  HiOutlineHome, 
  HiOutlineChatBubbleLeftRight,
  HiOutlineChatBubbleOvalLeftEllipsis,
  HiOutlineAcademicCap, 
  HiOutlineBell,
  HiOutlineEnvelope,
  HiOutlineUsers,
  HiOutlineUserGroup,
  HiChevronLeft,
  HiChevronRight,
  HiOutlineArrowLeftOnRectangle
} from "react-icons/hi2";
import { NavLink, useNavigate } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import logo from '../assets/logo.png';

const Sidebar = ({ isOpen, onClose, isCollapsed, setIsCollapsed }) => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user')) || null;

  const menu = [
    { id: 1, name: "Dashboard", icon: <HiOutlineHome size={22} />, slug: "dashboard" },
    { id: 2, name: "Chats", icon: <HiOutlineChatBubbleLeftRight size={22} />, slug: "chat" },
    { id: 9, name: "Personal chat", icon: <HiOutlineChatBubbleOvalLeftEllipsis size={22} />, slug: "personal-chat" },
    { id: 3, name: "Courses", icon: <HiOutlineAcademicCap size={22} />, slug: "courses" },
    { id: 4, name: "Users", icon: <HiOutlineUserGroup size={22} />, slug: "users" },
    { id: 5, name: "Contacts", icon: <HiOutlineUsers size={22} />, slug: "contacts" },
    { id: 7, name: "Alerts", icon: <HiOutlineBell size={22} />, slug: "alerts" },
    { id: 8, name: "Inbox", icon: <HiOutlineEnvelope size={22} />, slug: "inbox" },
  ];

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  const navLinkClasses = ({ isActive }) => 
    `flex items-center rounded-lg cursor-pointer transition-all duration-200 group ${
      isCollapsed ? 'px-2 py-2.5 justify-center' : 'px-3 py-2.5'
    } ${
      isActive 
        ? "bg-indigo-600 text-white shadow-md shadow-indigo-200" 
        : "text-gray-500 hover:bg-indigo-50 hover:text-indigo-600"
    }`;

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && (
        <div 
          className="fixed inset-0 z-40 bg-black/20 backdrop-blur-sm lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <aside className={`
        fixed lg:static inset-y-0 left-0 z-50
        transform transition-all duration-300 ease-in-out
        bg-white border-r border-gray-100 flex flex-col
        ${isOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
        ${isCollapsed ? "lg:w-[67px]" : "lg:w-[205px]"}
      `}>
        {/* Sidebar Header */}
        <div className="flex items-center h-20 px-4 justify-center relative flex-shrink-0">
          <NavLink to="/" className="flex items-center space-x-3 overflow-hidden">
            <img src={logo} alt="Logo" className="h-9 w-9 min-w-[36px]" />
            {!isCollapsed && (
              <span className="font-bold text-lg tracking-tight text-indigo-600 transition-opacity duration-300">
                IAATO
              </span>
            )}
          </NavLink>
          
          <button 
            onClick={onClose}
            className="lg:hidden absolute right-4 p-2 rounded-lg hover:bg-gray-100 text-gray-500"
          >
            <IoClose size={24} />
          </button>

          {/* Collapse toggle for desktop */}
          <button 
            onClick={() => setIsCollapsed(!isCollapsed)}
            className="hidden lg:flex absolute -right-3.5 top-7 items-center justify-center p-1.5 rounded-full bg-indigo-600 text-white hover:bg-indigo-700 shadow-lg z-50 transition-transform duration-300 active:scale-90"
          >
            {isCollapsed ? <HiChevronRight size={16} /> : <HiChevronLeft size={16} />}
          </button>
        </div>

        {/* Navigation Links */}
        <nav className={`flex-1 overflow-y-auto custom-scrollbar mt-4 space-y-1 ${isCollapsed ? 'px-2' : 'px-3'}`}>
          {menu.map((item) => (
            <NavLink
              key={item.id}
              to={`/${item.slug}`}
              title={isCollapsed ? item.name : ""}
              onClick={() => {
                if (window.innerWidth < 1024) onClose();
              }}
              className={navLinkClasses}
            >
              <span className="transition-transform group-hover:scale-110 flex-shrink-0">
                {item.icon}
              </span>
              {!isCollapsed && (
                <span className="ml-2 font-medium whitespace-nowrap overflow-hidden transition-opacity duration-300">
                  {item.name}
                </span>
              )}
            </NavLink>
          ))}
        </nav>

        {/* Sidebar Footer */}
        <div className={`p-3 border-t border-gray-50 ${isCollapsed ? 'px-2' : 'px-3'}`}>
          <button 
            onClick={handleLogout}
            title={isCollapsed ? "Logout" : ""}
            className={`flex items-center w-full rounded-xl transition-all duration-200 group text-red-600 hover:bg-red-50 ${
              isCollapsed ? 'px-2 py-3 justify-center' : 'px-3 py-3'
            }`}
          >
            <HiOutlineArrowLeftOnRectangle size={22} className="transition-transform group-hover:-translate-x-1 flex-shrink-0" />
            {!isCollapsed && <span className="ml-2 font-medium">Logout</span>}
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
